const trinityGradeOption = ({kid_name, ordering, current_trinity_stage, stage_progress_percent, trinity_opt_out}) => {

  if (!kid_name || !current_trinity_stage || trinity_opt_out || !current_trinity_stage) return null;

  const translateGrade = (stage) => {
    if (stage.toLowerCase().includes('pre-initial')) {
      return 1
    }
    if (stage.toLowerCase().includes('initial')) {
      return 2
    }
   if (stage.toLowerCase().includes('grade 1')) {
      return 3
    }
    return 4
  }

  const trinityGradeData = {
    "order": ordering.trinity_grade,
    "name": "trinity_grade",
    "tracking": "trinity_grade",
    "colorOption": 4,
    "dataPoints": {
      current_trinity_stage: translateGrade(current_trinity_stage),
      stage_progress_percent
    }
  };
  return trinityGradeData;
}

export default trinityGradeOption;
